const SubscriptionCreativeIcon = ({ size = 24, color = '#9F7AEA', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16.2222 18.25H5.5C3.84314 18.25 2.5 16.9069 2.5 15.25V6.75C2.5 5.09315 3.84315 3.75 5.5 3.75H18.5C20.1569 3.75 21.5 5.09315 21.5 6.75V13.1227"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 15V11M10.5 15V11M6 11V8.75C6 7.50736 7.00736 6.5 8.25 6.5C9.49264 6.5 10.5 7.50736 10.5 8.75V11M6 11H10.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5 6.5V15H14C16.2091 15 18 13.2091 18 11V10.5C18 8.29086 16.2091 6.5 14 6.5H13.5Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8807 19.4029C20.6733 19.9229 19.943 19.9387 19.7134 19.4281L18.0412 15.7107C17.8094 15.1954 18.3163 14.6572 18.8445 14.8576L22.8573 16.3805C23.3855 16.5809 23.4077 17.3199 22.8925 17.5517L22.1525 17.8846L23.3668 19.0723C23.613 19.3131 23.6218 19.7066 23.3869 19.9584C23.1443 20.2186 22.7349 20.2286 22.4802 19.9803L21.1627 18.6958L20.8807 19.4029Z"
                fill={color}
            />
        </svg>
    )
}

export default SubscriptionCreativeIcon
